/* global G */

import { setKey } from 'lib/util'

/**
 * Updates the list of all notification with the latest notification data if necessary
 *
 * @param {string} type             type of the notification
 * @param {string} [target='list']  key of the list component
 * @returns {function(*): function(*, ...[*]): Promise<*[]>}
 */
export const updateList = (type, target = 'list') => module => async (components, ...args) => {
  const { [target]: listComponent } = components
  const groupData = module?.[G.ADAPTER]?.[G.NOTIFICATION]?.[G.GROUP]?.[type]?.[G.DATA] || {}
  const { data, page } = groupData || {}

  if (data?.length) {
    setKey(data, 'data', listComponent[G.STATE])
    setKey({}, 'update', listComponent[G.STATE])
    setKey(page, 'page', listComponent[G.STATE])
  }

  return args
}
